import { OnInit, ViewContainerRef } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { SidenavService } from '@ml/core/services';
import { map } from 'rxjs/operators';
import { MediaObserver } from '@angular/flex-layout';
var RightSidenavComponent = /** @class */ (function () {
    function RightSidenavComponent(mediaObserver, sidenavService) {
        this.mediaObserver = mediaObserver;
        this.sidenavService = sidenavService;
    }
    Object.defineProperty(RightSidenavComponent.prototype, "_sidenavContent", {
        set: function (value) {
            this.sidenavService.sidenavContent = value;
        },
        enumerable: true,
        configurable: true
    });
    RightSidenavComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.opened$ = this.sidenavService.opened$;
        this.width$ = this.sidenavService.width$.pipe(map(function (value) {
            return _this.mediaObserver.isActive('lg') ? value : 100;
        }));
    };
    RightSidenavComponent.prototype.onClose = function () {
        this.sidenavService.close();
    };
    return RightSidenavComponent;
}());
export { RightSidenavComponent };
